import { Injectable } from '@angular/core';
import { RESTServiceBase, CacheTypes } from '../../common/service.base';
import { DataEntryDescriptor, FormOrganizationDescriptor } from './model/dataentry';
import { List } from '../../common/model/List_T';
import { AppConfig } from '../../configuration/app.config';
import { AuthService } from '../../services/auth.service';
import { View } from '../../common/model/view';

@Injectable()
export class DataEntryService extends RESTServiceBase {

  constructor(
    authService: AuthService,
    config: AppConfig,
  ) {
    super(
      'v1',
      'DataEntryManagement',
      authService,
      config.DEMSConfig
    );
  }

  public create(dataentry: DataEntryDescriptor): Promise<DataEntryDescriptor> {
    return super.post<DataEntryDescriptor>(
      new DataEntryDescriptor({
        id: undefined,
        href: undefined,

        rootDataEntryId: dataentry.rootDataEntryId,
        formId: dataentry.formId,
        organizationId: dataentry.organizationId,
        periodStart: dataentry.periodStart,
        reference: dataentry.reference,
        version: dataentry.version,
        dataEntryState: dataentry.dataEntryState,
        dataEntryProcessingState: dataentry.dataEntryProcessingState,
        submittedById: dataentry.submittedById,
        submittedOn: dataentry.submittedOn,
        dueDate: dataentry.dueDate,
        warnDate: dataentry.warnDate,
        validationState: dataentry.validationState,
        validatedOn: dataentry.validatedOn,
        clerkId: dataentry.clerkId,
        additionalInformation: dataentry.additionalInformation,
        createdById: dataentry.createdById,
        createdOn: dataentry.createdOn,
        modified: dataentry.modified,
        deleted: dataentry.deleted
      }));
  }

  public getDataEntries(view?: View): Promise<List<DataEntryDescriptor>> {
    return super.get<List<DataEntryDescriptor>>(undefined, view);
  }

  public delete(id: string): Promise<void> {
    return super.delete(id);
  }

  public update(id: string, dataentry: DataEntryDescriptor): Promise<DataEntryDescriptor> {
    return super.put<DataEntryDescriptor>(id, dataentry);
  }

  public getById(id: string, noCache = false): Promise<DataEntryDescriptor> {
    return super.get<DataEntryDescriptor>(id, undefined, undefined, CacheTypes.NoCache);
  }

  public getFormOrganizationRelations(view?: View): Promise<FormOrganizationDescriptor[]> {
    return super.get<FormOrganizationDescriptor[]>(undefined, view, 'forg');
  }

  public batchExport(view?: View): Promise<string> {
    return super.get(undefined, view, 'batch');
  }

  public async isServiceAvailable(): Promise<boolean> {
    return await super.isServiceAvailable();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/dataentry/dataentry.service.ts